angular.module('registration')

.controller('PreRegistrationController', ['$scope', '$q', '$state', '$uibModal', '$state', 'Notification', 'ModalHandler', 'ProviderInvitation', 'Registration',
    function ($scope, $q, $state, $uibModal, $state, Notification, ModalHandler, ProviderInvitation, Registration) {

        /**
         * Validate email address - reject if User account with this email address already exists.
         * 
         * @param {String} email email address to validate
         */
        $scope.checkEmail = function (email) {
            if (!email) {
                return $q.reject();
            }

            var d = $q.defer();
            
            ProviderInvitation.validate({email: email}, function(success) {
                d.resolve();

            }, function(failure) {
                console.log('Failure: ' + JSON.stringify(failure));

                if (failure.data.status == 'registered') {
                    Notification.error('invitation.email.register');

                } else if(failure.data.status == 'invited') {
                    $scope.resendProvider = failure.data;
                    Notification.error('invitation.email.invited', {resend: function() {
                        ProviderInvitation.resend({id: $scope.resendProvider.id}, function(success) {
                            var modalInstance = $uibModal.open({
                                templateUrl: 'partials/registration_email_send_message.html',
                                controller: 'RegistrationEmailResendModalController'
                            });
                            ModalHandler.set(modalInstance);
                        }, function(failure){
                            Notification.error(failure.data.message[0]);
                        });
                    }});
                }
                
                d.reject();
            });
            
            return d.promise;
        };

        /**
         * Send pre-registration request to the server and redirect if successful.
         * @param {Object} self_invitation 
         */
        $scope.createSelfInvitation = function(self_invitation) {
            console.log(JSON.stringify(self_invitation));

            Registration.preRegister(self_invitation,
                function success(response) {
                    console.log('Successfully sent pre-registration');
                    $state.go('pre_registration_confirmation');
                }, function failure(response) {

                    if (response && response.data && response.data.errors === 'bad.email.address') {
                        Notification.error('bad.email.address');
                    } else {
                        Notification.error('default.error');
                    }
                });
        };
    }])

.controller('PreRegistrationConfirmationController', [
    function () {
    }]);
